<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <div class="row">
        <!-- File -->
        <div class="col-sm-6">
          <div class="card">
            <div class="card-header">
              <i class="fa fa-file"></i><strong>File</strong>
            </div>

            <div class="card-block">
              <div class="form-group">
                <label for="canonical_url">Canonical URL</label>
                <input type="text" class="form-control" id="canonical_url" v-model="file.canonical_url" readonly>
              </div>

              <div class="form-group">
                <label for="crc">CRC</label>
                <input type="text" class="form-control" id="crc" v-model="file.crc" readonly>
              </div>

              <div class="form-group">
                <label for="size">Size</label>
                <input type="text" class="form-control" id="size" v-bind:value="file.size | prettyBytes" v-if="file.size" readonly>
              </div>

              <div class="form-group">
                <label for="version">Version</label>
                <input type="text" class="form-control" id="version" v-model="file.version" readonly>
              </div>

              <div class="form-group">
                <label for="real_url">Real URL</label>
                <a v-bind:href="file.real_url"><input type="text" class="form-control" id="real_url" v-model="file.real_url" readonly></a>
              </div>
            </div>
          </div>
        </div>

        <!-- Properties -->
        <div class="col-sm-6">
          <div class="card">
            <div class="card-header">
              <i class="fa fa-file-code-o"></i><strong>Properties</strong>
            </div>

            <div class="card-block">
              <div class="form-group" v-for="(value, key) in file.properties">
                <label>{{key}}</label>
                <input type="text" class="form-control" v-bind:value="value" readonly>
              </div>

            </div>
          </div>
        </div>
      </div>

      <!-- History -->
      <div class="row" >
        <div class="col-sm-12">
          <div class="card">
            <div class="card-header">
              <strong><i class="fa fa-history"></i> History</strong>
            </div>
            <div class="card-block">
              <table class="table table-condensed table-hover">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>CRC</th>
                    <th>Size</th>
                    <th>Real URL</th>
                    <th>Properties</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="fileHistory in history">
                    <tr v-bind:class="{'table-warning': isLatest(fileHistory)}">
                      <td>
                        {{ fileHistory.timestamp | parseTimestamp | moment('LLL')}}
                      </td>
                      <td>
                        {{fileHistory.crc}}
                      </td>
                      <td>
                        {{fileHistory.size | prettyBytes }}
                      </td>
                      <td>
                        <a v-bind:href="fileHistory.real_url">{{fileHistory.real_url}}</a>
                      </td>
                      <td>
                        <span v-for="(value, key) in fileHistory.properties">
                          <span class="small text-muted">{{key}}: </span><span class="small">{{value}} </span>
                        </span>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import files from 'services/files'
import utils from 'services/utils'

export default {
  name: 'file',
  data () {
    return {
      file: {},
      history: []
    }
  },
  created () {
    this.getFile()
    this.getHistory()
  },
  methods: {
    getFile () {
      files.get(this, this.$route.params.id)
    },
    getHistory () {
      files.history(this, this.$route.params.id)
    },
    isLatest (fileHistory) {
      return this.file.crc === fileHistory.crc
    }
  },
  filters: {
    parseTimestamp (timestamp) {
      return utils.parseTimestamp(timestamp)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/files/File.vue